<template>

    <modal-with-custom-content ref="modal"
                               :modalId="modalId"
                               :hideBottomCloseButton="true"
                               class="px-5"
    >

                <div class="d-flex flex-column justify-content-center">

                    <p class="text-md-center">{{ description }}</p>

                    <div class="modal-buttons m-auto">

                        <button-with-loading-component
                                class="btn btn-secondary btn-confirmation disable-dark mr-2"
                                :text="confirmText || translate.home.yes"
                                @click.native="onConfirm"
                                e2e-id="confirmation-modal-yes-btn"
                        ></button-with-loading-component>

                        <button-with-loading-component
                                class="btn btn-primary btn-confirmation disable-dark"
                                :text="cancelText || translate.home.no"
                                @click.native="onCancel"
                                e2e-id="confirmation-modal-no-btn"
                        ></button-with-loading-component>

                    </div>
            </div>
    </modal-with-custom-content>
</template>

<script>
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent.vue";
import ModalWithCustomContentComponent from "@/components/partials/ModalWithCustomContentComponent.vue";

export default {
    components: {'modal-with-custom-content': ModalWithCustomContentComponent, ButtonWithLoadingComponent},
    props: {
        modalId: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        confirmText: {
            type: String,
        },
        cancelText: {
            type: String,
        },
    },
    methods: {
        onConfirm() {
            this.$emit("confirm");
        },
        onCancel() {
            this.$emit("cancel");
        },
    },
    computed: {
        ...mapState(['translate'])
    },
};
</script>
